import Component from "vue-class-component";
import ModalRequeteur from "./modalRequeteur/modalRequeteur";
import EventConstants from "../Controls/EventConstants";
import $ from "jquery";
import { RequeteurDto } from "../../dto/GenApi.iNotPaie.Dto/RequeteurDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EventBus } from "../Controls/EventBus";
import { ParametresInstance } from "../Controls/Parameters";
import { champsRequeteur } from "./requeteurListeChamps";
import { domainesRequeteur } from "./requeteurListeDomaine";
import { RequeteurDomaineEnum } from "../../dto/GenApi.iNotPaie.Dto/RequeteurDomaineEnum";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ModelRequeteDto } from "../../dto/GenApi.iNotPaie.Dto/ModelRequeteDto";
import { Vue, Watch } from "vue-property-decorator";
import { ModelItemDto } from "../../dto/GenApi.iNotPaie.Dto/ModelItemDto";

interface itemPreview {
	id: number;
	order: number;
	value: string;
}

interface categoriePreview {
	id: number;
	type: string;
	list: itemPreview[];
}

@Component({
	components: {
		ModalRequeteur: require("./modalRequeteur/modalRequeteur.vue.html"),
		FiltreDateComponent: require("./FiltreDate/FiltreDate.vue.html"),
		FiltreDropComponent: require("./FiltreDrop/FiltreDrop.vue.html"),
		FiltreSelectionComponent: require("./FiltreSelection/FiltreSelection.vue.html")
	}
})
export default class RequeteurModifieurComponent extends Vue {
	private listCategoriePreview: categoriePreview[] = [];
	private globalCounterOrder = 0;
	private globalCounterID = 0;
	private domaineSelected = -1;
	private requeteur!: RequeteurDto;
	private isLoading = false;
	private isResult = false;
	private model: ModelRequeteDto = {
		Id: 0,
		Style: { CanDelete: true },
		Filtres: [],
		Name: "",
		Items: [],
		Orders: [],
		EstArchive: false
	};

	public champsRequeteur = champsRequeteur;
	public domainesRequeteur = domainesRequeteur;
	public modalRequeteur?: ModalRequeteur = undefined;
	public currentOrderColumn = "";
	public orderingDesc = true;

	// Le composant est dans un keep-alive qui entoure le router
	// Pour éviter les problèmes autre part, un simple watch url permet de refresh les bonnes données et éviter les duplications
	@Watch('$route', { immediate: true, deep: true })
	public onUrlChange(): void {
		const route = this.$route;

		if (route.name == "Modifieur de requête" && route.params?.id) {
			this.initRequeteurModifieur();
		}
	}

	public initRequeteurModifieur(): void {
		this.ResetFields();

		ServicesFactoryInstance.ParametresService.getParametres((data) => {
			ParametresInstance.listeParametres = data;
		});

		this.modalRequeteur = this.$refs.modalRequeteur as ModalRequeteur;

		this.champsRequeteur.sort(function (a: any, b: any) {
			if (a.Name < b.Name) {
				return -1;
			}
			if (a.Name > b.Name) {
				return 1;
			}

			return 0;
		});

		this.GetData();
	}

	private GetData(): void {
		const ID = Number(this.$route.params.id);
		const cloneID = (this.$route.query.cloneID != undefined) ? Number(this.$route.query.cloneID) : 0;

		if (ID !== 0 || cloneID !== 0) {
			ServicesFactoryInstance.ModelRequeteService.getModel((ID !== 0) ? ID : cloneID, (data) => {
				this.model = data;

				if (ID == 0) {
					this.model.Name = "";
					this.model.Descript = "";
					this.model.Id = 0;
				}

				this.CheckColExist();
				ServicesFactoryInstance.RequeteurService.getData(
					this.model!,
					(data) => {
						this.requeteur = data;
						this.$forceUpdate();
					}
				);
				this.BuildPreview();
			});
		}

		this.$forceUpdate();
	}

	private BuildPreview(): void {
		for (const item of this.model.Items) {
			this.ClickFilter(item);
		}
	}

	private CheckColExist(): void {
		let col;
		for (col of this.champsRequeteur) {
			col.Check = false;
		}
		for (const item of this.model!.Items) {
			for (col of this.champsRequeteur) {
				if (item.Name == col.Name) {
					col.Check = true;
				}
			}
		}
	}

	private ClickFilter(champ: any): void {
		champ.Check = !champ.Check;

		// ---------------------------------------------- IF CHECKED (ADD)
		if (champ.Check) {
			// IF CATEG EXIST
			if (this.listCategoriePreview.filter((list) => list.id == champ.Domaine).length == 1) {
				// ADD ITEM
				this.listCategoriePreview.forEach((element) => {
					if (element.id == champ.Domaine) {
						element.list.push({
							id: this.globalCounterID,
							order: this.globalCounterOrder,
							value: champ.Name
						});
					}
				});
				// IF CATEG NOT EXIST
			} else {
				this.domainesRequeteur.forEach((element) => {
					if (element.Code == champ.Domaine) {
						element.Check = true;
					}
				});

				this.listCategoriePreview.push({
					type: this.ChangeTitlePreview(champ.Domaine),
					id: champ.Domaine,
					list: [
						{
							id: this.globalCounterID,
							order: this.globalCounterOrder,
							value: champ.Name
						}
					]
				});

				// BLOCAGE
				this.ChangeStateDomaine(false, champ.Domaine);
			}

			this.domainesRequeteur.forEach((element) => {
				if (element.Code == champ.Domaine) {
					element.Counter++;
				}
			});

			this.globalCounterID++;

			// ---------------------------------------------- IF UNCHECKED (DELETE)
		} else {
			let selectedOrder = 0;

			// Delete
			this.listCategoriePreview.forEach((categoriePreview, index) => {
				if (categoriePreview.id == champ.Domaine) {
					categoriePreview.list.forEach((itemPreview, indexTwo) => {
						if (itemPreview.value == champ.Name) {
							selectedOrder = itemPreview.order;
							categoriePreview.list.splice(indexTwo, 1);
						}

						if (!categoriePreview.list.length) {
							this.domainesRequeteur.forEach((element) => {
								if (element.Code == champ.Domaine) {
									element.Check = false;
								}
							});

							this.listCategoriePreview.splice(index, 1);

							// DEBLOCAGE
							this.ChangeStateDomaine(true, champ.Domaine);
						}
					});
				}
			});

			// DECREMENT COUNTER
			this.domainesRequeteur.forEach((element) => {
				if (element.Code == champ.Domaine) {
					element.Counter--;
				}
			});

			// REORDER
			this.listCategoriePreview.forEach((categoriePreview) => {
				categoriePreview.list.forEach((itemPreview) => {
					if (itemPreview.order > selectedOrder) {
						itemPreview.order = itemPreview.order - 1;
					}
				});
			});
		}

		const lengths = this.listCategoriePreview.map(a => a.list.length);

		this.globalCounterOrder = lengths.reduce(function(a: number, b: number) {
			return a + b;
		}, 0);
	}

	private ChangeStateDomaine(valueState: boolean, currentDomaine: number): void {
		if (currentDomaine == RequeteurDomaineEnum.Bulletin) {
			this.domainesRequeteur.forEach((element) => {
				if (element.Code == RequeteurDomaineEnum.Reglement ||
					element.Code == RequeteurDomaineEnum.Absence) {
					element.State = valueState;
				}
			});
		}

		if (currentDomaine == RequeteurDomaineEnum.Reglement) {
			this.domainesRequeteur.forEach((element) => {
				if (element.Code == RequeteurDomaineEnum.Bulletin ||
					element.Code == RequeteurDomaineEnum.Absence) {
					element.State = valueState;
				}
			});
		}

		if (currentDomaine == RequeteurDomaineEnum.Absence) {
			this.domainesRequeteur.forEach((element) => {
				if (element.Code == RequeteurDomaineEnum.Bulletin ||
					element.Code == RequeteurDomaineEnum.Reglement) {
					element.State = valueState;
				}
			});
		}
	}

	private ChangeTitlePreview(value: number): string {
		let result = "Erreur";

		this.domainesRequeteur.forEach(domaine => {
			if (domaine.Code == value) {
				result = domaine.Name;
			}
		});

		return result;
	}

	private FilterChangeSelect(ToAdd: any): void {
		let index = 0;
		let push = true;
		for (const filtre of this.model!.Filtres) {
			if (
				ToAdd.Filtre.Domaine == filtre.Domaine &&
				ToAdd.Filtre.Prop == filtre.Prop
			) {
				push = ToAdd.Value != filtre.Value;
				this.model!.Filtres.splice(index, 1);
			}
			index++;
		}

		if (push) {
			this.model!.Filtres.push({
				Domaine: ToAdd.Filtre.Domaine,
				Prop: ToAdd.Filtre.Prop,
				Operator: ToAdd.Operator,
				Value: ToAdd.Value
			});
		}
		ServicesFactoryInstance.RequeteurService.getData(
			this.model!,
			(data) => {
				this.requeteur = data;
				this.$forceUpdate();
			}
		);
	}

	private FilterChangeDropOrDate(ToAdd: any): void {
		let index = 0;
		ToAdd.Value = "\"" + ToAdd.Value + "\"";

		for (const filtre of this.model!.Filtres) {
			if (
				ToAdd.Filtre.Domaine == filtre.Domaine &&
				ToAdd.Filtre.Prop == filtre.Prop
			) {
				this.model!.Filtres.splice(index, 1);
			}
			index++;
		}
		this.model!.Filtres.push({
			Domaine: ToAdd.Filtre.Domaine,
			Prop: ToAdd.Filtre.Prop,
			Operator: ToAdd.Operator,
			Value: ToAdd.Value
		});
		ServicesFactoryInstance.RequeteurService.getData(
			this.model!,
			(data) => {
				this.requeteur = data;
				this.$forceUpdate();
			}
		);
	}

	public StartEndDateChange(): void {
		const start = (document.getElementById("start")! as HTMLInputElement)
			.value;
		const end = (document.getElementById("end")! as HTMLInputElement).value;
		if (start == "" || end == "") {
			return;
		}
		const Ystart = start.substr(0, 4);
		const Mstart = start.substr(5, 2);
		const Dstart = start.substr(8, 2);
		const Yend = end.substr(0, 4);
		const Mend = end.substr(5, 2);
		const Dend = end.substr(8, 2);
		if (
			this.model!.Filtres.length > 0 &&
			this.model!.Filtres[0].Domaine == null
		) {
			this.model!.Filtres.splice(0, 1);
		}

		this.model!.Filtres.unshift({
			Value:
				"contrat.DateDebutContrat < DbFunctions.CreateDateTime(" +
				Ystart +
				"," +
				Mstart +
				"," +
				Dstart +
				", 0, 0, 0) && (contrat.DateFinContrat == null || contrat.DateFinContrat > DbFunctions.CreateDateTime(" +
				Yend +
				"," +
				Mend +
				"," +
				Dend +
				", 0, 0, 0))"
		});
		ServicesFactoryInstance.RequeteurService.getData(
			this.model!,
			(data) => {
				this.requeteur = data;
				this.$forceUpdate();
			}
		);
	}

	private CloseTab(): void {
		EventBus.$emit(EventConstants.CLOSE_TAB, {
			path: this.$router.currentRoute.path
		});
	}

	private OpenModal(): void {
		if (this.modalRequeteur != undefined && this.model != undefined) {
			this.modalRequeteur.Init(this.model);
			$("#modalRequeteur").modal("show");
		}
	}

	private BuildModele(): void {
		this.isLoading = true;
		this.model!.Items = [];
		this.domaineSelected = -1;

		for (const col of this.champsRequeteur) {
			if (col.Check) {
				this.model!.Items.push({
					Index: this.model!.Items.length + 1,
					Name: col.Name,
					Domaine: col.Domaine,
					Prop: col.Prop,
					FuncName: col.FuncName
				});
			} else {
				let index = 0;
				for (const filtre of this.model!.Filtres) {
					if (
						col.Domaine == filtre.Domaine &&
						col.Prop == filtre.Prop
					) {
						this.model!.Filtres.splice(index, 1);
					}
					index++;
				}
			}
		}

		// SORT ITEMS MODEL FINAL
		const modelItemSort: ModelItemDto[] = [];

		for (let i = 0; i < this.globalCounterOrder; i++) {
			for (const categorie of this.listCategoriePreview) {
				for (const item of categorie.list) {
					if (item.order === i) {
						modelItemSort.push(this.model.Items.filter(modelItem => modelItem.Name === item.value)[0]);
						break;
					}
				}
			}
		}

		this.model.Items = modelItemSort;

		ServicesFactoryInstance.RequeteurService.getData(this.model!, (data) => {
			this.requeteur = data;
			this.isLoading = false;
			this.isResult = true;
			this.$forceUpdate();
		}
		);
	}

	private DeleteItemPreview(value: string, indexDomaine: number): void {
		const currentField = this.champsRequeteur.filter((field) => field.Domaine == indexDomaine && field.Name == value);
		this.ClickFilter(currentField[0]);
	}

	private ResetFields(): void {
		this.listCategoriePreview = [];
		this.globalCounterOrder = 0;
		this.globalCounterID = 0;
		this.isResult = false;
		this.isLoading = false;
		this.ResetDomaine();

		this.model = {
			Id: 0,
			Style: { CanDelete: true },
			Filtres: [],
			Name: "",
			Items: [],
			Orders: [],
			EstArchive: false
		};

		this.champsRequeteur.forEach((element) => {
			element.Check = false;
		});

		this.domainesRequeteur.forEach((element) => {
			element.Check = false;
			element.State = true;
			element.Counter = 0;
		});
	}

	private ModifyFields(): void {
		this.isResult = false;
	}

	private ClickDomaine(domaine: any): void {
		this.domaineSelected = domaine.Code;
	}

	private ResetDomaine(): void {
		this.domaineSelected = -1;
	}

	private DragStart(evt: any, item: any): void {
		evt.dataTransfer.dropEffect = "move";
		evt.dataTransfer.effectAllowed = "move";
		evt.target.classList.add("drag-start");
		evt.dataTransfer.setData("itemID", item.order);

		evt.path[2].classList.add("wrap-item-active");
		evt.path[4].classList.add("wrap-active");
	}

	private DragEnd(evt: any): void {
		evt.preventDefault();
		evt.target.classList.remove("drag-start");
		evt.path[2].classList.remove("wrap-item-active");
		evt.path[4].classList.remove("wrap-active");
	}

	private DragOver(evt: any): void {
		evt.preventDefault();
		evt.target.classList.add("drag-over");
	}

	private DragLeave(evt: any): void {
		evt.preventDefault();
		evt.target.classList.remove("drag-over");
	}

	private Drop(evt: any): void {
		evt.target.classList.remove("drag-over");

		const orderA = evt.dataTransfer.getData("itemID");
		const orderB = evt.target.attributes.order.value;

		let itemAID = -1;
		let itemBID = -1;

		// GET ELEMENT (DON'T CHANGE IN SAME TIME)
		this.listCategoriePreview.forEach((categorie) => {
			categorie.list.forEach((item) => {
				if (item.order == orderA) {
					itemAID = item.id;
				}

				if (item.order == orderB) {
					itemBID = item.id;
				}
			});
		});

		// SET ELEMENT (IN SAME TIME)
		this.listCategoriePreview.forEach((categorie) => {
			categorie.list.forEach((item) => {
				if (item.id == itemAID) {
					item.order = Number(orderB);
				}

				if (item.id == itemBID) {
					item.order = Number(orderA);
				}
			});
		});
	}

	public OrderBy(columnName: string): void {
		if (this.currentOrderColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.currentOrderColumn = columnName;
		this.DoOrder();
	}

	public DoOrder(): void {
		const orderingDesc = this.orderingDesc;
		const columnName = this.currentOrderColumn;
		if (this.requeteur!.Grid.Row != undefined) {
			this.requeteur!.Grid.Row.sort(function(a: ParametreDto, b: ParametreDto) {
				if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
				if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	public GetClassOfOrder(columnName: string, desc: boolean): string {
		if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "icons";
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/requeteurModifieur.ts